import React, { useMemo } from "react";
import { Divider } from "@mui/material";
import { observer } from "mobx-react-lite";

import { SubscriptionPlan } from "../../../../../services/organization-subscription-plans/SubscriptionPlan";
import { translationService } from "../../../../../services/translation/TranslationService";
import { formatBytes, getLocalPrice, teraToBytes } from "../../../../../helpers/MathHelpers";
import "./composition.scss";

interface SubscriptionBenefitsProps {
  subscriptionPlanDetails: SubscriptionPlan;
}

export const SubscriptionBenefits = observer((props: SubscriptionBenefitsProps) => {
  const subscriptionPlan = props.subscriptionPlanDetails;

  const planStorageSpaceFormat = useMemo(() => {
    return formatBytes(teraToBytes(subscriptionPlan.storageSize), 0);
  }, [subscriptionPlan.storageSize]);

  return (
    <>
      <div className="included-benefits">
        <div className="benefit-container">
          <div className="large-label">
            {subscriptionPlan.minimumNumberOfSeats > 1
              ? subscriptionPlan.minimumNumberOfSeats + translationService.translate("SubscriptionPlans.card.seats")
              : subscriptionPlan.minimumNumberOfSeats + translationService.translate("SubscriptionPlans.card.seat")}
          </div>
          <Divider sx={{ borderBottomWidth: 2 }} style={{ margin: "10px 0" }} />
          <div className="small-label">
            {translationService.translate("SubscriptionPlans.card.full-rights")}
          </div>
        </div>
        <div className="benefit-container">
          <div className="large-label">
            {subscriptionPlan.numberOfGuestSeats
              ? subscriptionPlan.numberOfGuestSeats + translationService.translate("SubscriptionPlans.card.seats")
              : translationService.translate("SubscriptionPlans.card.unlimited")}
          </div>
          <Divider sx={{ borderBottomWidth: 2 }} style={{ margin: "10px 0" }} />
          <div className="small-label">
            {translationService.translate("SubscriptionPlans.card.view-rights")}
          </div>
        </div>
      </div>
      <div className="included-benefits">
        <div className="benefit-container">
          <div className="large-label">{`${planStorageSpaceFormat.amount} ${planStorageSpaceFormat.unit}`}</div>
          <Divider sx={{ borderBottomWidth: 2 }} style={{ margin: "10px 0" }} />
          <div className="small-label">
            {translationService.translate("SubscriptionPlans.card.storage")}
          </div>
        </div>
        <div className="benefit-container">
          <div className="large-label">
            {subscriptionPlan.videoAnalyserCalls +
              translationService.translate("SubscriptionPlans.card.calls")}
          </div>
          <Divider sx={{ borderBottomWidth: 2 }} style={{ margin: "10px 0" }} />
          <div className="small-label">
            {translationService.translate("SubscriptionPlans.card.analysis")}
          </div>
        </div>
      </div>
      <div className="small-opacity-label align-left">
        <span>
          {`${translationService.translate("SubscriptionPlans.card.extra-video-analysis-costs-part-1")}`}
        </span>
        <span className="inline-label">
          {`${translationService.translate("SubscriptionPlans.card.extra-video-analysis-costs-part-2", {
            price: getLocalPrice(subscriptionPlan.extraVideoAnalysisUnitCallPrice!)
          })}`}
        </span>
        <span>
          {`${translationService.translate("SubscriptionPlans.card.extra-video-analysis-costs-part-3")}`}
        </span>
      </div>
    </>
  );
});
